const servers = {
  localhost: {
    /// contactApi: 'https://sissi.dev.vieres.net/contacts/api',
    // invoicing: 'https://sissi.dev.vieres.net/invoicing',
    sissi: "http://localhost:9123/sissi/api",
    contactApi: "http://localhost:4000/api",
    invoicing: "http://localhost:9124/invoicing",
    website: "https://qs.viennaresidence.com",
  },
  "react.vieres.dev": {
    sissi: "https://sissi.vieres.dev/sissi/api",
    contactApi: "https://sissi.vieres.dev/contacts",
    invoicing: "https://sissi.vieres.dev/invoicing",
    website: "https://vieres.dev",
  },
  "react.sissi.dev.vieres.net": {
    sissi: "https://sissi.dev.vieres.net/sissi/api",
    contactApi: "https://sissi.dev.vieres.net/contacts/api",
    invoicing: "https://sissi.dev.vieres.net/invoicing",
    website: "https://dev.vieres.net",
  },
  "react.sissi.qs.viennaresidence.com": {
    sissi: "https://sissi.qs.viennaresidence.com/sissi/api",
    contactApi: "https://sissi.qs.viennaresidence.com/contacts",
    invoicing: "https://sissi.qs.viennaresidence.com/invoicing",
    website: "https://qs.viennaresidence.com",
  },
  "react.sissi.viennaresidence.com": {
    sissi: "https://sissi.viennaresidence.com/sissi/api",
    contactApi: "https://sissi.viennaresidence.com/contacts",
    invoicing: "https://sissi.viennaresidence.com/invoicing",
    website: "https://viennaresidence.com",
  },
};

export function getSissiCoreUrl() {
  const server = servers[window.location.hostname];
  if (!server) {
    return "/";
  }
  return server.sissi;
}

export function getSissiInvoicingUrl() {
  const server = servers[window.location.hostname];
  if (!server) {
    return "/";
  }
  return server.invoicing;
}

export function getSissiEncoreUrl() {
  const server = servers[window.location.hostname];
  if (!server) {
    return "/";
  }
  return server.contactApi;
}

export function getWebsiteUrl() {
  const server = servers[window.location.hostname];
  if (!server) {
    return "/";
  }
  return server.website;
}

export default servers;
